import {
  TweenMax,
  TimelineMax,
  Sine,
  Linear
} from "gsap";
//  Power2, Elastic, CSSPlugin ,Tweenmax
export function play() {

  // 抱小孩
  // TweenMax.to(`[data-name="people_mom"] [data-name="body"] 
  // .a1d213e1-f326-480d-8d2c-66db0a9aab05,.a1d213e1-f326-480d-8d2c-66db0a9aab05,.ff395ec6-a706-4292-893d-b429add341c7,.ef1521cb-2726-425a-a391-8af8f261be25 `, 2 ,{
  //   x: 10,
  //   y: 2
  // }).repeat(-1).yoyo(true)

  TweenMax.from(`[data-name="360 (數據跑動)"] .b9ed94a8-2f94-470b-aa7e-f233aac93b56`,2,{
    css: {
      opacity: 0
    },
    ease: Linear.easeNone
  },0.3).repeat(-1).yoyo(true)

  TweenMax.from(`[data-name="360 (數據跑動)"] .b121fa02-0ffb-4f6d-babe-25bde9352458`,2,{
    css: {
      opacity: 0
    },
    ease: Linear.easeNone
  },0.3).delay(1.2).repeat(-1).yoyo(true)

  TweenMax.staggerFrom(`[data-name="數據02"] path `, 2, {
    opacity: 0
  }, 0.2).repeat(-1)

  TweenMax.staggerFrom(`[data-name="數據03"] ellipse`, 2, {
    opacity: 0
  }, 0.5).repeat(-1).yoyo(true)

  TweenMax.staggerFrom(`[data-name="360 (數據跑動)"] line, [data-name="360 (數據跑動)"] polygon `, 0.7, {
    opacity: 0
  }, 0.2).repeat(-1)

  TweenMax.set(`[data-name="hand(晃動)"]`, {
    transformOrigin: "100% 0%"
  })
  TweenMax.to(`[data-name="hand(晃動)"]`, 5, {
    rotate: -20,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)


  TweenMax.set(`[data-name="son_hand"]`, {
    transformOrigin: "100% 0%"
  })
  TweenMax.to(`[data-name="son_hand"]`, 3, {
    rotate: -10,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)


  //手機亮
  TweenMax.to("feGaussianBlur", 1, {
    attr: {
      stdDeviation: 10,
      ease: Linear.easeIn
    }
  }, 0.5).repeat(-1).yoyo(true)

  let son_phone = `[data-name="son_hand"] .e0d353a8-29fe-4090-ae01-ac0ff8f2dc21`
  TweenMax.set(son_phone, {
    fill: 'white',
    opacity: 1
  })
  TweenMax.to(son_phone , 2, {
    attr: {
      opacity: 0.5,
      filter: "url(#dropshadow)",
    },
  }).repeat(-1).yoyo(true)


  TweenMax.to(`[data-name="people_wheelchair"], [data-name="Layer 20"], [data-name="people_wheelchair＿front"], [data-name="old_man"], [data-name="son_hand"]`, 3, {
    x: -15,
    y: 10,
    ease: Sine.easeInOut,
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name="people_kid"]`, {
    transformOrigin: "100% 0%"
  })
  TweenMax.to(`[data-name="people_kid"]`, 3, {
    rotate: -2,
    x: -10,
    y: 5,
  }).repeat(-1).yoyo(true)


  TweenMax.to(`[data-name="people_mom"]`, 3, {
    x: -1,
    y: 5,
  }).repeat(-1).yoyo(true)


  TweenMax.set(`[data-name="people_man"] [data-name="hand"]`, {
    transformOrigin: "0% 50%"
  })

  TweenMax.to(`[data-name="people_man"] [data-name="hand"]`, 2, {
    rotate: -30
  }).repeat(-1).yoyo(true)


  
  

}